class CountdownTimer extends HTMLElement {
    constructor() {
        super();
        this.endDate = new Date(this.getAttribute("data-end-date"));
        this.days = this.querySelector("#days");
        this.hours = this.querySelector("#hours");
        this.minutes = this.querySelector("#minutes");
        this.seconds = this.querySelector("#seconds");
    }

    connectedCallback() {
        // Check if already expired
        if (this.endDate <= new Date()) {
            return;
        }

        // Show timer
        this.classList.remove("hidden");

        this._updateDisplay();
        this._startCountdown();
    }

    disconnectedCallback() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    _updateDisplay() {
        const now = new Date();
        const distance = this.endDate - now;

        if (distance < 0) {
            clearInterval(this.interval);
            this._showExpiredState();
            return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        this.days.textContent = String(days).padStart(2, "0");
        this.hours.textContent = String(hours).padStart(2, "0");
        this.minutes.textContent = String(minutes).padStart(2, "0");
        this.seconds.textContent = String(seconds).padStart(2, "0");
    }

    _startCountdown() {
        this.interval = setInterval(() => {
            this._updateDisplay();
        }, 1000);
    }
}

customElements.define("countdown-timer", CountdownTimer);
